import { CircularProgress, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LoginContext } from "../context/ContextProvider";
import "./cart.css";
const Cart = () => {
  const { id } = useParams("");
  const history = useNavigate();
  const { account, setAccount } = useContext(LoginContext);
  // console.log("account", account);
  // const [individualdata, setIndividualdata] = useState("");
  const [inddata, setIndedata] = useState("");

  const getIndividualData = async () => {
    const res = await fetch(`https://amazonbackendapp.onrender.com/getproductsone/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    // console.log(data);

    if (!data || data.status === 422) {
      // console.log("No Data Available");
    } else {
      // console.log("GetData")
      // setIndividualdata(data);
      setIndedata(data);
    }
  };

  
  // add to cart function

  const addToCart = async (id) => {
    console.log(id);
    const checkres = await fetch(`https://amazonbackendapp.onrender.com/addcart/${id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        // individualdata,
        inddata
      }),
      credentials: "include",
    });

    const data1 = await checkres.json();
    // console.log("frontend Data in cart", data1);

    if (checkres.status === 401 || !data1) {
      alert("user Invalid");
      console.log("User Invalid");
    } else {
      alert("Item added to cart successfully !");
      // console.log("Data added to cart successfully");
      setAccount(data1);
      history("/buynow");
    }
  };

  useEffect(() => {
    setTimeout(() => {
      getIndividualData();
    }, 2000);
  }, [id]);

  return (
    <div className="cart_section">
            {inddata && Object.keys(inddata).length &&
                <div className="cart_container">
                    <div className="left_cart">
                        <img src={inddata.detailUrl} alt="cart" />
                        <div className="cart_btn">
                            <button className="cart_btn1" onClick={() => addToCart(inddata.id)}>Add to Cart</button>
                            <button className="cart_btn2">Buy Now</button>
                        </div>

                    </div>
                    <div className="right_cart">
                        <h3>{inddata.title.shortTitle}</h3>
                        <h4>{inddata.title.longTitle}</h4>
                        <Divider />
                        <p className="mrp">M.R.P. : <del>₹{inddata.price.mrp}</del></p>
                        <p>Deal of the Day : <span style={{ color: "#B12704" }}>₹{inddata.price.cost}.00</span></p>
                        <p>You save : <span style={{ color: "#B12704" }}> ₹{inddata.price.mrp - inddata.price.cost} ({inddata.price.discount}) </span></p>

                        <div className="discount_box">
                            <h5 >Discount : <span style={{ color: "#111" }}>{inddata.discount}</span> </h5>
                            <h4>FREE Delivery : <span style={{ color: "#111", fontWeight: "600" }}>Oct 8 - 21</span> Details</h4>
                            <p style={{ color: "#111" }}>Fastest delivery: <span style={{ color: "#111", fontWeight: "600" }}> Tomorrow 11AM</span></p>
                        </div>
                        <p className="description">About the Iteam : <span style={{ color: "#565959", fontSize: "14px", fontWeight: "500", letterSpacing: "0.4px" }}>{inddata.description}</span></p>
                    </div>
                </div>
            }



            {!inddata ? <div className="circle">
                <CircularProgress />
                <h2> Loading....</h2>
            </div> : ""}
        </div>
  );
};

export default Cart;
